import type { Assortment_AdminFragment } from '../../graphql';
import type { ScenarioLocation } from '../../lib/planningData';
import type { MultiKey } from '../core/MultiKey';
import type {
  PortCostData,
  MarcuraPortCosts,
  MarcuraPortCostParams,
} from './context';
import type { LocationId } from '@seaber/common/core/entries';

export class PortCostMap implements MarcuraPortCosts {
  map: MultiKey<PortCostData, MarcuraPortCostParams>;
  locationsById: Map<LocationId, ScenarioLocation>;
  assortmentsById: Map<number, Assortment_AdminFragment>;

  constructor(
    map: MultiKey<PortCostData, MarcuraPortCostParams>,
    locationsById: Map<LocationId, ScenarioLocation>,
    assortmentsById: Map<number, Assortment_AdminFragment>,
  ) {
    this.map = map;
    this.locationsById = locationsById;
    this.assortmentsById = assortmentsById;
  }

  get(locationId: LocationId, assortmentId: number): PortCostData | undefined {
    const portExternalId = this.locationsById.get(locationId)?.externalId;
    const assortmentGroupExternalId =
      this.assortmentsById.get(assortmentId)?.assortmentGroupByAssortmentGroup
        ?.externalId;
    if (!portExternalId || !assortmentGroupExternalId) {
      return undefined;
    }
    return this.map.get(portExternalId, assortmentGroupExternalId);
  }

  set(data: PortCostData): void {
    this.map.set(data, data.marcura_port_id, data.marcura_group_id);
  }
}
